<template>
  <div>
    <index-card fluid>
      <template slot="header">
        <v-row>
          <v-col class="white--text d-flex justify-space-between align-center headline">
            <div class="d-flex align-center">
              <v-btn icon color="blue-grey darken-1" :to="{name: 'Home'}"><v-icon color="white">mdi-arrow-left</v-icon></v-btn>
              <v-btn class="ml-2" color="white black--text" @click="dialog_new_deposit = true"><v-icon left>mdi-plus</v-icon>novo depósito</v-btn>
            </div>
            <span>Depósitos</span>
            <div class="d-flex">
              <BtnCreateDataExport 
                class="mx-3"
                api_model="Deposit" 
                action="Deposits"
                :filters="filters"
              ></BtnCreateDataExport>
              <v-btn text icon color="white" aria-label="Atualizar lista" @click="onHeaderRefreshDeposits">
                <v-icon color="white">mdi-refresh</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
      <template slot="data_table">
        <v-card>
          <v-card-text class="py-0">
            <router-view @doneFilter="handleDoneFilter"></router-view>
          </v-card-text>
        </v-card>
      </template>
    </index-card>

    <NewPayment
      v-if="dialog_new_deposit"
      kind="deposit"
      @done="onHeaderRefreshDeposits"
      @close="dialog_new_deposit = false"
    ></NewPayment>
  </div>
</template>

<script>
export default {
  name: 'Deposits',
  components: {
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    BtnCreateDataExport: () => import("@/components/data_export/BtnCreateDataExport.vue"),
    NewPayment: () => import('@/_backoffice/_financial/components/order_payment/NewPayment.vue'),
  },
  provide() {
    const vm = this
    return {
      registerDepositsListReload(fn) {
        vm.depositsListReload = fn
      },
    }
  },
  data(){
    return {
      filters: {},
      depositsListReload: null,
      dialog_new_deposit: false,
    }
  },
  methods: {
    handleDoneFilter(filter){
      this.filters = {...filter}
    },
    onHeaderRefreshDeposits() {
      if (this.depositsListReload) this.depositsListReload()
    },
  },
}
</script>
